export default __webpack_public_path__ + "static/char-v-55-zh-Hant-7218063e82c069dac6722115c014b006.mp4";